"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _translate = _interopRequireDefault(require("../translate"));

var _deleteButton = _interopRequireDefault(require("../delete-button"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _conf = _interopRequireDefault(require("../../conf"));

var _formatDate = require("../../lib/format-date");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var setTargetUrl = function setTargetUrl(target, id) {
  if (target === 'farm') {
    return "farm/".concat(id);
  } else {
    return "".concat(target, "-release/").concat(id);
  }
};

var MessageList = /*#__PURE__*/function (_React$Component) {
  _inherits(MessageList, _React$Component);

  function MessageList(props) {
    var _this;

    _classCallCheck(this, MessageList);

    _this = _possibleConstructorReturn(this, (MessageList.__proto__ || Object.getPrototypeOf(MessageList)).call(this, props));
    _this.state = {
      isLoading: false,
      messageData: []
    };
    _this.deleteMessage = _this.deleteMessage.bind(_assertThisInitialized(_this));
    _this.renderDetailLink = _this.renderDetailLink.bind(_assertThisInitialized(_this));
    _this.load = _this.load.bind(_assertThisInitialized(_this));
    _this.markAsRead = _this.markAsRead.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MessageList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var columns = [{
        title: t('date'),
        render: function render(val, row) {
          return (0, _formatDate.formatDate)(row.date_create);
        },
        prop: 'date_create'
      }, {
        title: t('message'),
        render: function render(val, row) {
          return t(row.message);
        },
        prop: 'message'
      }, {
        title: t('username'),
        key: 'username',
        prop: 'username'
      }, {
        title: t('last name'),
        key: 'last_name',
        prop: 'last_name'
      }, {
        title: t('canton'),
        render: function render(val, row) {
          // eslint-disable-next-line camelcase
          return row.canton_name ? row.canton_name : '-';
        },
        prop: 'canton_name',
        defaultContent: '-'
      }, {
        title: t('city'),
        key: 'city',
        prop: 'city'
      }, {
        title: t('project'),
        render: function render(val) {
          return t(val);
        },
        prop: 'project_key'
      }, {
        title: '',
        render: this.renderDetailLink
      }, {
        title: '',
        render: function render(val, row) {
          return _this2.deleteMessage(parseInt(row.id));
        }
      }];
      var staticTexts = {
        search: t('search'),
        noData: t('no data'),
        loading: t('loading data'),
        all: t('all'),
        pageSize: t('results per page')
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "message-list-comp"
      }, /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id', 'project_key'],
        enableSort: true,
        columns: columns,
        initialData: this.state.messageData,
        initialPageLength: 20,
        staticTexts: staticTexts,
        isLoading: this.state.isLoading,
        showSearch: false,
        initialSortBy: {
          prop: 'date_create',
          order: 'descending'
        },
        buildRowOptions: function buildRowOptions(row) {
          return {
            className: row.is_read ? '' : 'unread'
          };
        }
      }));
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      this.setState({
        isLoading: true
      });

      var loadData = function loadData(url, name) {
        fetch(url, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (objects) {
          _this3.setState(function (prev) {
            prev[name] = objects;
            prev.isLoading = false;
            return prev;
          });
        }).catch(console.error);
      };

      loadData(_conf.default.api.messagesApiUrlTemplate(this.props.i18n.language), 'messageData');
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(id) {
      return /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
        id: id,
        history: this.props.history,
        urlTemplate: _conf.default.api.messageDeleteApiUrlTemplate,
        url: _conf.default.api.messageDeleteApiUrlTemplate,
        label: this.props.t('delete message'),
        language: this.props.i18n.language,
        labelConfirmButton: this.props.t('delete message'),
        labelCancel: this.props.t('cancel'),
        labelConfirmation: this.props.t('Are you sure the delete this message?'),
        labelSuccess: this.props.t('The message was deleted'),
        labelConfirmed: this.props.t('The message was deleted'),
        labelDeleteFailed: this.props.t('Message could not be deleted'),
        labelNext1: this.props.t('close'),
        pathNext1: '/',
        labelNext2: this.props.t('To message list'),
        loadData: this.load
      });
    }
  }, {
    key: "markAsRead",
    value: function markAsRead(row, ctrlKey) {
      var _this4 = this;

      var uri = _conf.default.api.messageReadApiUrlTemplate(this.props.i18n.language, row.id);

      fetch(uri, {
        credentials: 'include',
        method: 'PUT'
      }).then(_fetchUtils.default.checkStatus).then(function () {
        var url = setTargetUrl(row.target_type, row.target_id);

        if (ctrlKey) {
          if (row.is_read === 0) {
            var index = _this4.state.messageData.findIndex(function (message) {
              return row.id === message.id;
            });

            _this4.setState(function (prev) {
              row.is_read = 1;
              prev.messageData[index] = row;
              return prev;
            });
          }

          window.open(url, '_blank');
          return;
        }

        _this4.props.history.push(url);
      });
    }
  }, {
    key: "renderDetailLink",
    value: function renderDetailLink(val, row) {
      var _this5 = this;

      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        onClick: function onClick(event) {
          _this5.markAsRead(row, event.ctrlKey || event.metaKey);
        },
        title: t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
  }]);

  return MessageList;
}(_react.default.Component);

MessageList.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    isInitialized: _propTypes.default.bool
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  })
};

var _default = (0, _translate.default)(MessageList);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/message-list/index.js
// module id = 265
// module chunks = 0